<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system';
</script>

<Alert
	heading={$format('text_blu_trv_sensor_pairing', {
		default: 'Pair BLU TRV with the BLU H&T or Door/Window sensor.',
	})}
	message={$format('text_blu_trv_pairing_sensor_info', {
		default:
			'Press and hold the Reset button on the BLU H&T or Door/Window sensor for over 10 seconds and click Next button.',
	})}
	type="info"
/>
